import axios from "axios";
import {
  CANCEL_SUBSCRIPTION,
  CLEAR_SUBSCRIBERS,
  CLEAR_SUBSCRIPTIONS,
  GET_SUBSCRIBERS,
  GET_SUBSCRIPTIONS,
  GET_ACTIVE_SUBSCRIPTIONS,
  SUBSCRIPTION_FAIL,
  GET_MENTORS,
  GET_GIFTED_USERS,
} from "./types";

// Get user subscriptions
export const getSubscriptions = () => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIPTIONS });
  try {
    const res = await axios.post(`/api/subscribe/subscriptions`);

    dispatch({
      type: GET_SUBSCRIPTIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get mentors
export const getMentors = (formData) => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIPTIONS });

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/subscribe`, formData, config);

    dispatch({
      type: GET_MENTORS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get mentors and innovators elgible for a gifted course
export const getMentorsInnovators = (formData) => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIPTIONS });

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/subscribe/users`, formData, config);

    dispatch({
      type: GET_GIFTED_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get active subscriptions
export const getActiveSubscriptions = (userId) => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIPTIONS });
  try {
    const res = await axios.post(`/api/subscribe/activesubs/${userId}`);

    dispatch({
      type: GET_ACTIVE_SUBSCRIPTIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get current Mentor profile subscribers
export const getSubscribers = (userId) => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIBERS });

  try {
    const res = await axios.post(`/api/subscribe/subscribers/${userId}`);

    dispatch({
      type: GET_SUBSCRIBERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Cancel Subscription
export const cancelSubscription = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "http://localhost:5000/cancel_subscription",
      formData,
      config
    );

    dispatch({
      type: CANCEL_SUBSCRIPTION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
